<template>
  <div class="d-flex justify-content-center" id="modal-mailreset">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="m-portlet__head modal-resetpass-title">
          <h3 class="m-portlet__head-text">
            {{ $t("message.ob_update_user_email") }}
          </h3>
        </div>
        <hr class="w-100 mt-0 mb-6" />
        <form name="form.changeMail" action @submit.prevent="updateUserEmail()">
          <div class="email-pass-container">
            <h5 class="modal-subtitle mb-8">
              {{ $t("message.ob_update_user_email_subtitle") }}
            </h5>
            <div class="group-reset-mail">
              <input
                data-vs-input="email"
                class="reset-mail-input"
                type="text"
                id="changeMail.mail"
                v-validate="'required|email'"
                name="mail"
                required
                v-model="email"
              />
              <span class="highlight"></span>
              <span class="bar mt-1"></span>
              <label class="reset-mail-label">{{
                $t("message.ei_titleList_text_2_2")
              }}</label>
            </div>

            <div>
              <p class="m--font-danger" v-for="error in errors.collect('mail')">
                {{ error }}
              </p>
            </div>
          </div>

          <div class="d-flex m-4 h-12">
            <button
              data-vs-button="clear-field-email"
              type="button"
              @click="clearFields"
              class="btn btn-secondary mr-3 w-100"
            >
              {{ $t("message.cancel") }}
            </button>
            <button
              v-if="!loadingMail"
              :disabled="errors.any()"
              type="submit"
              class="btn btn-primary w-100"
              data-vs-button="submit-update-email"
            >
              {{ $t("message.ei_personal_info_save_changes") }}
            </button>
            <button
              v-if="loadingMail"
              type="submit"
              class="btn btn-primary w-100"
              data-vs-button="submit-update-email"
            >
              <div class="m-loader m-loader--light"></div>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Vue } from "vue-property-decorator";
import UserManagement from "../../../apiClient/UserManagement";

export default {
   props: {
    email: String
  },
  data() {
    return {
      userNew: UserManagement,
      loadingMail: false,
      loadingReset: false,
      email: this.email,
    };
  },
  created() {
    this.userNew = new UserManagement();
  },

  methods: {
    clearFields() {
      $("#updateUserEmail").modal("hide");
      this.email = "";
    },
    updateUserEmail() {
      this.loadingMail = true;
      this.userNew
        .updateUserManagement(this.$route.params.id, {email:this.email})
        .then((resp) => {
          if (resp.status === 200) {
            this.loadingMail = false;
            swal({
              type: "success",
              title: `${this.$t("message.employee_edit_success")}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t(
                "message.billboard_form_post_button_confirm"
              )}`,
            }).then(() => {
              this.$emit('mailChanged', this.email);
              $("#updateUserEmail").modal("hide");
            });
          }
        })
        .catch((err) => {
         this.loadingMail = false;
          const {data} = err.response;
            swal({
              type: "error",
              title: `${this.$t("message.actions.error")}`,
              text: data.codes[0].code === 'USER_EMAIL_DUPLICATED' ? 
              `${this.$t("message.ob_reactive_user_email_exists")}`:
              `${this.$t("message.employees_list_modal_reset_pass_incorrect")}` ,
              showConfirmButton: true,
              confirmButtonText: `${this.$t(
                "message.billboard_form_post_button_confirm"
              )}`,
            });
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";
@import "./public/assets/scss/components/_resetpass.scss";
.modal-dialog {
  width: 400px;
  margin: 1.75rem auto;
}
.modal-subtitle {
  display: flex;
  justify-content: flex-start;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 14px !important;
  color: $textSecondary;
}
</style>
